/**
 * Application entry.
 *
 * Kept to almost nothing on purpose: mount React, start the sync engine, and
 * get out of the way. Anything that runs before first paint delays the moment
 * the person sees their files, which is the one number this product is judged on.
 */
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import './index.css'

const container = document.getElementById('root')
if (!container) throw new Error('index.html is missing #root')

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
